import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { dAPI } from 'appSrc/api';
import { PrimaryButton } from 'appSrc/components/UI';
import moment from 'moment-timezone';
import NewScheduleModal from './NewScheduleModal';
import ScheduleCard from './ScheduleCard';
import SidePanel from '../SidePanel';
import { blockSetFactory } from '../utils';
import style from './styles/style.module.css';

class Schedules extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            upcoming: [],
            past: [],
            dateList: [],
            showCreateModal: false,
        };
    }
    componentDidMount() {
        this.loadSchedules();
    }
    loadSchedules = () => {
        dAPI.get( '/admin/dltv/schedules' )
        .then( ( response ) => {
            var upcoming = [], past = [], dateList=[];
            const timeNow = moment.utc();

            for( var i = 0; i < response.length; i++ ) {
                var schedule = { ...response[ i ] };
                //todo: add block validation here
                schedule.blocks = blockSetFactory( schedule.blocks );
                schedule.errorsPresent = schedule.blocks.findIndex( item => ( Object.keys( item.errors || {} ).length > 0 ) ) !== -1;

                schedule.runDate = moment.utc( schedule.run_date, 'MM/DD/YYYY' );
                if( timeNow.isSameOrBefore( schedule.runDate, 'day' ) ) {
                    upcoming.push( schedule );
                } else {
                    past.push( schedule );
                }
                dateList.push( new Date( ...schedule.runDate.toArray().slice( 0, 4 ) ) );
            }
            past.reverse();
            this.setState( {
                upcoming,
                past,
                dateList,
            } );
        } );
    }
    createNewSchedule = ( dateStr ) => {
        dAPI.post( '/admin/dltv/schedules', {
            run_date: dateStr,
        } )
        .then( () => {
            this.setState( { showCreateModal: false } );
            this.loadSchedules();
        } );
    }




    render() {
        const { upcoming, past } = this.state;

        return (
            <section className={ style.schedules }>
                <Helmet>
                    <title>Admin - DLTV Schedules</title>
                </Helmet>
                <SidePanel />
                <div className={ style.head }>
                    <h2>DLTV Schedules</h2>
                    <div className={ style.buttonGroup }>
                        <PrimaryButton label='New Schedule'
                        onClick={ () => { this.setState( { showCreateModal: true } ); } } />
                    </div>
                </div>
                <div className={ style.body }>
                    <h3>Upcoming</h3>
                    <div className={ style.scheduleGrid }>
                        { upcoming.map( ( schedule ) => ( <ScheduleCard key={ schedule.id } schedule={ schedule } /> ) ) }
                    </div>
                    <h3>Past</h3>
                    <div className={ style.scheduleGrid }>
                        { past.map( ( schedule ) => ( <ScheduleCard key={ schedule.id } schedule={ schedule } /> ) ) }
                    </div>
                </div>
                { this.state.showCreateModal &&
                    <NewScheduleModal exclude={ this.state.dateList } onSubmit={ this.createNewSchedule }
                    closeHandler={ () => { this.setState( { showCreateModal: false } ); } } />
                }
            </section>
        );
    }
}

export default connect()( Schedules );
